module.exports = __webpack_public_path__ + "static/media/enrpi-logo.cb64f692.svg";